module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kk-Ld.948cbf37.png";